// JsFromRoutes CacheKey 953689fdb76aa75282fc0a9e85a00b67
//
// DO NOT MODIFY: This file was automatically generated by JsFromRoutes.
import { definePathHelper } from '@js-from-routes/client'

export default {
  create: /* #__PURE__ */ definePathHelper('post', '/sessions'),
  new: /* #__PURE__ */ definePathHelper('get', '/sessions/new'),
  destroy: /* #__PURE__ */ definePathHelper('delete', '/sessions/:id'),
}
